"use client";

import { c as _c } from "react/compiler-runtime";
import React, { useMemo, useState } from "react";
import type { ApiDrop } from "@/generated/models/ApiDrop";
import type { ApiWave } from "@/generated/models/ApiWave";
import useDeviceInfo from "@/hooks/useDeviceInfo";
import WaveDropsAll from "../drops/wave-drops-all";
import { CreateDropWaveWrapper, CreateDropWaveWrapperContext } from "../CreateDropWaveWrapper";
import type { ActiveDropState } from "@/types/dropInteractionTypes";
import { ActiveDropAction } from "@/types/dropInteractionTypes";
import PrivilegedDropCreator from "../PrivilegedDropCreator";
import { useAndroidKeyboard } from "@/hooks/useAndroidKeyboard";
import { DropMode } from "../dropComposer.types";
import { WaveDropLayerProvider } from "../drops/WaveDropLayerContext";
import { useWaveEligibility } from "@/contexts/wave/WaveEligibilityContext";
interface SingleWaveDropChatProps {
  readonly wave: ApiWave;
  readonly drop: ApiDrop;
  readonly winningThreshold?: number | null | undefined;
  readonly winningThresholdMinDurationMs?: number | null | undefined;
  readonly isVotingClosed?: boolean | undefined;
  readonly isVotingControlsLocked?: boolean | undefined;
}
export const SingleWaveDropChat: React.FC<SingleWaveDropChatProps> = t0 => {
  const $ = _c(41);
  const {
    wave,
    drop,
    winningThreshold: t1,
    winningThresholdMinDurationMs: t2,
    isVotingClosed: t3,
    isVotingControlsLocked: t4
  } = t0;
  const winningThreshold = t1 === undefined ? null : t1;
  const winningThresholdMinDurationMs = t2 === undefined ? null : t2;
  const isVotingClosed = t3 === undefined ? false : t3;
  const isVotingControlsLocked = t4 === undefined ? false : t4;
  const {
    isApp
  } = useDeviceInfo();
  const {
    isVisible: isKeyboardVisible
  } = useAndroidKeyboard();
  const {
    updateEligibility
  } = useWaveEligibility();
  const t5 = isKeyboardVisible ? "0px" : "calc(env(safe-area-inset-bottom))";
  let t6;
  if ($[0] !== t5) {
    t6 = {
      paddingBottom: t5
    };
    $[0] = t5;
    $[1] = t6;
  } else {
    t6 = $[1];
  }
  const inputContainerStyle = t6;
  let t7;
  if ($[2] !== drop) {
    t7 = {
      action: ActiveDropAction.REPLY,
      drop,
      partId: 1
    };
    $[2] = drop;
    $[3] = t7;
  } else {
    t7 = $[3];
  }
  const [activeDrop, setActiveDrop] = useState(t7);
  let t8;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t8 = t9 => {
      const {
        targetDrop,
        partId,
        action
      } = t9;
      setActiveDrop({
        action,
        drop: targetDrop,
        partId
      });
    };
    $[4] = t8;
  } else {
    t8 = $[4];
  }
  const handleDropAction = t8;
  let t9;
  if ($[5] !== drop) {
    t9 = () => {
      setActiveDrop({
        action: ActiveDropAction.REPLY,
        drop,
        partId: 1
      });
    };
    $[5] = drop;
    $[6] = t9;
  } else {
    t9 = $[6];
  }
  const resetActiveDrop = t9;
  let t10;
  if ($[7] !== updateEligibility || $[8] !== wave.chat || $[9] !== wave.id || $[10] !== wave.participation || $[11] !== wave.voting || $[12] !== wave.wave) {
    t10 = () => {
      updateEligibility(wave.id, {
        authenticated_user_eligible_to_chat: wave.chat.authenticated_user_eligible,
        authenticated_user_eligible_to_vote: wave.voting.authenticated_user_eligible,
        authenticated_user_eligible_to_participate: wave.participation.authenticated_user_eligible,
        authenticated_user_admin: wave.wave.authenticated_user_eligible_for_admin
      });
    };
    $[7] = updateEligibility;
    $[8] = wave.chat;
    $[9] = wave.id;
    $[10] = wave.participation;
    $[11] = wave.voting;
    $[12] = wave.wave;
    $[13] = t10;
  } else {
    t10 = $[13];
  }
  let t11;
  if ($[14] !== updateEligibility || $[15] !== wave) {
    t11 = [updateEligibility, wave];
    $[14] = updateEligibility;
    $[15] = wave;
    $[16] = t11;
  } else {
    t11 = $[16];
  }
  React.useEffect(t10, t11);
  let t12;
  if ($[17] === Symbol.for("react.memo_cache_sentinel")) {
    t12 = {
      mobileMenuZIndexClassName: "tw-z-[1020]",
      mobileDialogZIndexClassName: "tw-z-[1030]"
    };
    $[17] = t12;
  } else {
    t12 = $[17];
  }
  let t13;
  if ($[18] === Symbol.for("react.memo_cache_sentinel")) {
    t13 = t14 => {
      const {
        drop: repliedDrop,
        partId: partId_0
      } = t14;
      return handleDropAction({
        targetDrop: repliedDrop,
        partId: partId_0,
        action: ActiveDropAction.REPLY
      });
    };
    $[18] = t13;
  } else {
    t13 = $[18];
  }
  let t14;
  if ($[19] !== activeDrop || $[20] !== drop.id || $[21] !== isVotingClosed || $[22] !== isVotingControlsLocked || $[23] !== wave || $[24] !== winningThreshold || $[25] !== winningThresholdMinDurationMs) {
    t14 = <div className="tw-min-h-0 tw-flex-1"><WaveDropsAll waveId={wave.id} wave={wave} onReply={t13} activeDrop={activeDrop} initialDrop={null} unreadCount={wave.metrics.your_unread_drops_count} dropId={drop.id} isMuted={wave.metrics.muted} winningThreshold={winningThreshold} winningThresholdMinDurationMs={winningThresholdMinDurationMs} isVotingClosed={isVotingClosed} isVotingControlsLocked={isVotingControlsLocked} /></div>;
    $[19] = activeDrop;
    $[20] = drop.id;
    $[21] = isVotingClosed;
    $[22] = isVotingControlsLocked;
    $[23] = wave;
    $[24] = winningThreshold;
    $[25] = winningThresholdMinDurationMs;
    $[26] = t14;
  } else {
    t14 = $[26];
  }
  let t15;
  if ($[27] !== inputContainerStyle || $[28] !== isApp) {
    t15 = isApp ? inputContainerStyle : {
      paddingBottom: "calc(env(safe-area-inset-bottom))"
    };
    $[27] = inputContainerStyle;
    $[28] = isApp;
    $[29] = t15;
  } else {
    t15 = $[29];
  }
  let t16;
  if ($[30] !== activeDrop || $[31] !== drop.id || $[32] !== resetActiveDrop || $[33] !== wave) {
    t16 = <CreateDropWaveWrapper context={CreateDropWaveWrapperContext.SINGLE_DROP}><PrivilegedDropCreator activeDrop={activeDrop} onCancelReplyQuote={resetActiveDrop} onDropAddedToQueue={resetActiveDrop} wave={wave} dropId={drop.id} fixedDropMode={DropMode.CHAT} /></CreateDropWaveWrapper>;
    $[30] = activeDrop;
    $[31] = drop.id;
    $[32] = resetActiveDrop;
    $[33] = wave;
    $[34] = t16;
  } else {
    t16 = $[34];
  }
  let t17;
  if ($[35] !== t15 || $[36] !== t16) {
    t17 = <div style={t15} className="tw-mt-auto">{t16}</div>;
    $[35] = t15;
    $[36] = t16;
    $[37] = t17;
  } else {
    t17 = $[37];
  }
  let t18;
  if ($[38] !== t14 || $[39] !== t17) {
    t18 = <WaveDropLayerProvider value={t12}><div className="tw-flex tw-h-full tw-min-h-0 tw-flex-1 tw-flex-col"><div className="tw-relative tw-flex tw-min-h-0 tw-flex-1 tw-flex-col tw-overflow-hidden tw-border-y-0 tw-border-l-0 tw-border-iron-800 tw-bg-iron-950 lg:tw-border lg:tw-border-r lg:tw-border-solid"><div className="tw-relative tw-flex tw-min-h-0 tw-flex-1 tw-flex-col"><div className="tw-flex tw-min-h-0 tw-w-full tw-flex-1 tw-flex-col"><div className="tw-flex tw-min-h-0 tw-w-full tw-flex-1 tw-flex-col">{t14}{t17}</div></div></div></div></div></WaveDropLayerProvider>;
    $[38] = t14;
    $[39] = t17;
    $[40] = t18;
  } else {
    t18 = $[40];
  }
  return t18;
};